import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import Swiper core and required modules
import SwiperCore, { Pagination, Scrollbar } from "swiper";
// modules styles
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
// swiper bundle styles
import "swiper/swiper-bundle.min.css";
// swiper core styles
import "swiper/swiper.min.css";
import "../assets/css/style2.css";
import patient_image2 from "../assets/img/default.jpg";
import DashSideNav from "./DashSideNav";
// install Swiper modules
SwiperCore.use([Pagination, Scrollbar]);

export default function Dashboard() {
  const [seizing, setSeizing] = useState([]);
  const [recovering, setRecovering] = useState([]);
  const [notCritical, setNotCritical] = useState([]);

  // const userId = useSelector((state) => state.loginData.userId);
  const token = useSelector((state) => state.loginData.token);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/patient_doctor`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (response.data.code === 401) {
        localStorage.clear();
        window.location.reload();
      } else {
        if (response.data.status === true) {
          setSeizing(response.data.data.seizing.details);
          setRecovering(response.data.data.recovering.details);
          setNotCritical(response.data.data.not_critical.details);
        }
      }
    };
    getData();
  }, [token]);

  return (
    <>
      <section className="dashbpard-sections">
        <div className="container-fluid">
          <div className="dashboard-inner row">
            <div className="left-sidebar col-lg-2">
              <nav className="navbar navbar-expand-lg">
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon" />
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <DashSideNav />
                </div>
              </nav>
            </div>
            <div className="patient-overview col-lg-10">
              <div className="overview-mainbox">
                <div className="overview-title">
                  <h3>Patient Overview</h3>
                  <a className="sort-filter" href="/#">
                    Sort{" "}
                    <svg
                      width={30}
                      height={30}
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                      <rect width={30} height={30} fill="url(#pattern0)" />
                      <defs>
                        <pattern
                          id="pattern0"
                          patternContentUnits="objectBoundingBox"
                          width={1}
                          height={1}
                        >
                          <use xlinkHref="#image0" transform="scale(0.005)" />
                        </pattern>
                        <image
                          id="image0"
                          width={200}
                          height={200}
                          xlinkHref="data:image/png;base64,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"
                        />
                      </defs>
                    </svg>
                  </a>
                </div>
                <div className="slide-boxes">
                  {/* Swiper */}
                  <div className="swiper mySwiper">
                    <div className="swiper-wrapper">
                      <div className="swiper-slide">
                        <div className="row">
                          <Swiper
                            slidesPerView={recovering.length > 1 ? "2" : "1"}
                            breakpoints={{
                              575: {
                                slidesPerView: 1,
                              },
                              640: {
                                slidesPerView: 2,
                              },
                            }}
                            scrollbar={{
                              hide: true,
                            }}
                            className="mySwiper"
                          >
                            {recovering ? (
                              recovering.map((item) => (
                                <div key={item.id}>
                                  <SwiperSlide key={item.id}>
                                    <div className="patient-box recovering">
                                      <div className="patient-info">
                                        <Link
                                          to={`/fileupload/${item.id}`}
                                          className="file-report"
                                          style={{ marginRight: "2%" }}
                                          href="/#"
                                        >
                                          Add EEG File
                                        </Link>
                                        <img
                                          className="patient-img"
                                          src={patient_image2}
                                          alt="patient-info"
                                        />

                                        <div className="patient-details">
                                          <h4 className="patient-name">
                                            {item.name}
                                          </h4>
                                          <div className="patient-injury">
                                            {item.age}
                                            {item.gender}- Status Epilepticus
                                          </div>
                                          <div className="patient-status">
                                            Seizure
                                          </div>
                                        </div>
                                      </div>
                                      <div className="patient-report">
                                        <Link
                                          to={`/visits/${item.id}`}
                                          className="full-report"
                                          style={{ marginRight: "2%" }}
                                          href="/#"
                                        >
                                          Full Report
                                        </Link>
                                        <a
                                          className="contact-technician"
                                          href="/#"
                                        >
                                          Contact{" "}
                                        </a>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                </div>
                              ))
                            ) : (
                              <div>None</div>
                            )}
                          </Swiper>
                          <Swiper
                            autoHeight="true"
                            slidesPerView={notCritical.length > 1 ? "2" : "1"}
                            slidesPerColumn="auto"
                            // slidesPerColumnFill="row"
                            spaceBetween={0}
                            breakpoints={{
                              575: {
                                slidesPerView: 1,
                              },
                              640: {
                                slidesPerView: 2,
                              },
                            }}
                            scrollbar={{
                              hide: true,
                            }}
                            className="mySwiper"
                          >
                            {notCritical ? (
                              notCritical.map((item) => (
                                <div key={item.id}>
                                  <SwiperSlide key={item.id}>
                                    <div className="patient-box not-critical">
                                      <div className="patient-info ">
                                        <Link
                                          to={`/fileupload/${item.id}`}
                                          className="file-report"
                                          style={{ marginRight: "2%" }}
                                          href="/#"
                                        >
                                          Add EEG File
                                        </Link>
                                        <img
                                          className="patient-img "
                                          src={patient_image2}
                                          alt="patient-info"
                                        />

                                        <div className="patient-details">
                                          <h4 className="patient-name">
                                            {item.name}
                                          </h4>
                                          <div className="patient-injury">
                                            {item.age}
                                            {item.gender}- Status Epilepticus
                                          </div>
                                          <div className="patient-status">
                                            Concussions
                                          </div>
                                        </div>
                                      </div>
                                      <div className="patient-report">
                                        <Link
                                          to={`/visits/${item.id}`}
                                          className="full-report"
                                          style={{ marginRight: "2%" }}
                                          href="/#"
                                        >
                                          Full Report
                                        </Link>
                                        <a
                                          className="contact-technician"
                                          href="/#"
                                        >
                                          Contact{" "}
                                        </a>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                </div>
                              ))
                            ) : (
                              <div>None</div>
                            )}
                          </Swiper>
                          <Swiper
                            autoHeight="true"
                            slidesPerView={seizing.length > 1 ? "2" : "1"}
                            slidesPerColumn="auto"
                            // slidesPerColumnFill="row"
                            spaceBetween={0}
                            breakpoints={{
                              575: {
                                slidesPerView: 1,
                              },
                              640: {
                                slidesPerView: 2,
                              },
                            }}
                            // pagination={{
                            //   clickable: true,
                            // }}
                            scrollbar={{
                              hide: true,
                            }}
                            className="mySwiper"
                          >
                            {seizing ? (
                              seizing.map((item) => (
                                <div key={item.id}>
                                  <SwiperSlide key={item.id}>
                                    <div className="patient-box seizing">
                                      <div className="patient-info">
                                        <Link
                                          to={`/fileupload/${item.id}`}
                                          className="file-report"
                                          style={{ marginRight: "2%" }}
                                          href="/#"
                                        >
                                          Add EEG File
                                        </Link>
                                        <img
                                          className="patient-img"
                                          src={patient_image2}
                                          alt="patient-info"
                                        />
                                        <div className="patient-details">
                                          <h4 className="patient-name">
                                            {item.name}
                                          </h4>
                                          <div className="patient-injury">
                                            {item.age}
                                            {item.gender}- Status Epilepticus
                                          </div>
                                          <div className="patient-status">
                                            Stroke
                                          </div>
                                        </div>
                                      </div>
                                      <div className="patient-report">
                                        <Link
                                          to={`/visits/${item.id}`}
                                          className="full-report"
                                          style={{ marginRight: "2%" }}
                                          href="/#"
                                        >
                                          Full Report
                                        </Link>
                                        <a
                                          className="contact-technician"
                                          href="/#"
                                        >
                                          Contact{" "}
                                        </a>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                </div>
                              ))
                            ) : (
                              <div>None</div>
                            )}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-pagination" />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="right-boxes col-lg-4">
              <div className="dashboard-inbox">
                <div className="inbox-title">
                  <h3>Patient Overview</h3>
                  <a className="sort-filter" href="/#">
                    <img src={box} alt="inbox-icon" />
                  </a>
                </div>
                <div className="inbox-body">
                  <div className="inbox-message">
                    <div className="message-details">
                      <div className="sender-name">Dr. Fisher</div>
                      <div className="message-day">Monday</div>
                    </div>
                    <div className="massage-content">
                      Kimberly Cousins stopped seizing. We took her off the
                      24-hour EEG. Additional PenEEG screening will be performed
                      later tonight.
                    </div>
                  </div>
                  <div className="inbox-message">
                    <div className="message-details">
                      <div className="sender-name">Dr. Paulson</div>
                      <div className="message-day">Sunday</div>
                    </div>
                    <div className="massage-content">
                      Danielle Cowell is not showing signs of Status. We treated
                      her with diazepam and she is showing general slowing
                      activity.
                    </div>
                  </div>
                  <div className="inbox-message">
                    <div className="message-details">
                      <div className="sender-name">Dr. Paulson</div>
                      <div className="message-day">Friday</div>
                    </div>
                    <div className="massage-content">
                      We will extend continuous EEG to additional 4 hours for
                      Devina Cook.
                    </div>
                  </div>
                  <div className="inbox-message">
                    <div className="message-details">
                      <div className="sender-name">Dr. Fisher</div>
                      <div className="message-day">Thursday</div>
                    </div>
                    <div className="massage-content">
                      Alexandar Matt put on 24-hour EEG after PenEEG screening.
                    </div>
                  </div>
                </div>
              </div>
              <div className="dashboard-inbox calendar-box">
                <div className="inbox-title">
                  <h3>Calendar</h3>
                  <a className="sort-filter" href="/#">
                    <img src={box} alt="inbox-icon" />
                  </a>
                </div>
                <div className="inbox-body calender-body">
                  <div className="calendar one">
                    <header>
                      <h4>APR 2021</h4>
                    </header>
                    <table>
                      <thead>
                        <tr>
                          <td>Su</td>
                          <td>Mo</td>
                          <td>Tu</td>
                          <td>We</td>
                          <td>Th</td>
                          <td>Fr</td>
                          <td>Sa</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="prev-month" />
                          <td className="prev-month" />
                          <td className="prev-month" />
                          <td className="prev-month" />
                          <td>1</td>
                          <td>2</td>
                          <td>3</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>5</td>
                          <td>6</td>
                          <td className="event">7</td>
                          <td className="event out">8</td>
                          <td className="event out">9</td>
                          <td>10</td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>12</td>
                          <td>13</td>
                          <td className="event out">14</td>
                          <td className="event">15</td>
                          <td>16</td>
                          <td>17</td>
                        </tr>
                        <tr>
                          <td className="event out">18</td>
                          <td className="event out">19</td>
                          <td>20</td>
                          <td>21</td>
                          <td>22</td>
                          <td>23</td>
                          <td>24</td>
                        </tr>
                        <tr>
                          <td className="current-day event">25</td>
                          <td>26</td>
                          <td>27</td>
                          <td>28</td>
                          <td className="event out">29</td>
                          <td className="event out">30</td>
                          <td />
                        </tr>
                        <tr>
                          <td />
                          <td className="next-month" />
                          <td className="next-month" />
                          <td className="next-month" />
                          <td className="next-month" />
                          <td className="next-month" />
                          <td className="next-month" />
                        </tr>
                      </tbody>
                    </table>
                  </div>{" "}
                  {/* end calendar */}
            {/* <div className="calendar">
                    <header>
                      <h4>May 2021</h4>
                    </header>
                    <table>
                      <thead>
                        <tr>
                          <td>Su</td>
                          <td>Mo</td>
                          <td>Tu</td>
                          <td>We</td>
                          <td>Th</td>
                          <td>Fr</td>
                          <td>Sa</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="prev-month" />
                          <td className="prev-month" />
                          <td className="prev-month" />
                          <td className="prev-month" />
                          <td className="prev-month" />
                          <td className="prev-month" />
                          <td>1</td>
                        </tr>
                        <tr>
                          <td className="event">2</td>
                          <td className="event out">3</td>
                          <td>4</td>
                          <td>5</td>
                          <td className="event out">6</td>
                          <td className="event out">7</td>
                          <td>8</td>
                        </tr>
                        <tr>
                          <td className="event out">9</td>
                          <td className="event">10</td>
                          <td>11</td>
                          <td>12</td>
                          <td>13</td>
                          <td>14</td>
                          <td>15</td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>17</td>
                          <td>18</td>
                          <td className="event out">19</td>
                          <td className="event out">20</td>
                          <td>21</td>
                          <td>22</td>
                        </tr>
                        <tr>
                          <td>23</td>
                          <td>24</td>
                          <td>25</td>
                          <td>26</td>
                          <td>27</td>
                          <td>28</td>
                          <td>29</td>
                        </tr>
                        <tr>
                          <td>30</td>
                          <td>31</td>
                          <td className="next-month" />
                          <td className="next-month" />
                          <td className="next-month" />
                          <td className="next-month" />
                          <td className="next-month" />
                        </tr>
                      </tbody>
                    </table>
                  </div>{" "} */}
            {/* </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      {/* Swiper JS */}
    </>
  );
}
